const Due = () => {
    return (
        <div>
            <h2>Due Report</h2>
        </div>
    )
}

export default Due;